
import { useState } from 'react';
import { Link } from 'react-router-dom';
import DeliveryMap from '../../components/features/DeliveryMap';

export default function TrackingPage() {
  const [trackingCode, setTrackingCode] = useState('');
  const [deliveryData, setDeliveryData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleTrackDelivery = () => {
    if (!trackingCode.trim()) return;
    
    setIsLoading(true);
    
    // Simulation de recherche
    setTimeout(() => {
      setDeliveryData({
        id: trackingCode,
        status: 'en_cours',
        driver: {
          name: 'Kouassi Jean',
          phone: '+225 07 12 34 56 78',
          rating: 4.8,
          vehicle: 'Moto Yamaha'
        },
        pickup: {
          lat: 5.3364,
          lng: -4.0267,
          address: 'Marché de Treichville, Abidjan'
        },
        delivery: {
          lat: 5.3600,
          lng: -3.9583,
          address: 'Université Félix Houphouët-Boigny, Cocody'
        },
        estimatedTime: 15,
        price: 1500
      });
      setIsLoading(false);
    }, 2000);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center space-x-2">
              <div className="w-8 h-8 bg-teal-600 rounded-lg flex items-center justify-center">
                <i className="ri-truck-line text-white text-lg"></i>
              </div>
              <span className="text-xl font-bold text-gray-900" style={{ fontFamily: '"Pacifico", serif' }}>
                ONAPILA
              </span>
            </Link>
            
            <nav className="hidden md:flex space-x-8">
              <Link to="/" className="text-gray-600 hover:text-teal-600 font-medium">Accueil</Link>
              <div className="relative group">
                <button className="text-gray-600 hover:text-teal-600 font-medium flex items-center">
                  Espaces
                  <i className="ri-arrow-down-s-line ml-1"></i>
                </button>
                <div className="absolute left-0 mt-2 w-48 bg-white rounded-lg shadow-lg border opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
                  <div className="py-2">
                    <Link to="/client-dashboard" className="block px-4 py-2 text-gray-700 hover:bg-gray-100">
                      <i className="ri-user-line mr-2"></i>
                      Espace Client
                    </Link>
                    <Link to="/livreur-dashboard" className="block px-4 py-2 text-gray-700 hover:bg-gray-100">
                      <i className="ri-truck-line mr-2"></i>
                      Espace Livreur
                    </Link>
                    <Link to="/restaurant-dashboard" className="block px-4 py-2 text-gray-700 hover:bg-gray-100">
                      <i className="ri-restaurant-line mr-2"></i>
                      Espace Restaurant
                    </Link>
                    <Link to="/commercant-dashboard" className="block px-4 py-2 text-gray-700 hover:bg-gray-100">
                      <i className="ri-store-line mr-2"></i>
                      Espace Commerce
                    </Link>
                  </div>
                </div>
              </div>
              <Link to="/tracking" className="text-teal-600 font-medium">Suivi</Link>
            </nav>
          </div>
        </div>
      </header>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Recherche de livraison */}
        <div className="bg-white rounded-xl shadow-lg p-6 mb-8">
          <div className="text-center mb-6">
            <h1 className="text-3xl font-bold text-gray-900 mb-2">Suivi de livraison</h1>
            <p className="text-gray-600">Entrez votre code de suivi pour voir l'évolution de votre commande</p>
          </div>

          <div className="max-w-md mx-auto">
            <div className="flex space-x-3">
              <input
                type="text"
                value={trackingCode}
                onChange={(e) => setTrackingCode(e.target.value)}
                placeholder="Ex: LIV-2024-001"
                className="flex-1 px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"
              />
              <button
                onClick={handleTrackDelivery}
                disabled={isLoading || !trackingCode.trim()}
                className="px-6 py-3 bg-teal-600 hover:bg-teal-700 disabled:bg-gray-400 text-white font-medium rounded-lg transition-colors whitespace-nowrap"
              >
                {isLoading ? (
                  <>
                    <i className="ri-loader-4-line animate-spin mr-2"></i>
                    Recherche...
                  </>
                ) : (
                  <>
                    <i className="ri-search-line mr-2"></i>
                    Suivre
                  </>
                )}
              </button>
            </div>
          </div>
        </div>

        {/* Résultats de suivi */}
        {deliveryData && (
          <div className="space-y-6">
            {/* Informations de la commande */}
            <div className="bg-white rounded-xl shadow-lg p-6">
              <div className="flex items-center justify-between mb-4">
                <h2 className="text-xl font-bold text-gray-900">Commande #{deliveryData.id}</h2>
                <span className="px-3 py-1 bg-orange-100 text-orange-800 rounded-full text-sm font-medium">
                  En cours de livraison
                </span>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {/* Informations livreur */}
                <div className="bg-gray-50 rounded-lg p-4">
                  <h3 className="font-semibold text-gray-900 mb-3">Votre livreur</h3>
                  <div className="flex items-center space-x-3 mb-3">
                    <div className="w-12 h-12 bg-teal-600 rounded-full flex items-center justify-center">
                      <i className="ri-user-line text-white text-lg"></i>
                    </div>
                    <div>
                      <p className="font-medium text-gray-900">{deliveryData.driver.name}</p>
                      <div className="flex items-center space-x-1">
                        <i className="ri-star-fill text-yellow-400 text-sm"></i>
                        <span className="text-sm text-gray-600">{deliveryData.driver.rating}</span>
                      </div>
                    </div>
                  </div>
                  <p className="text-sm text-gray-600 mb-2">
                    <i className="ri-motorbike-line mr-2"></i>
                    {deliveryData.driver.vehicle}
                  </p>
                  <button className="w-full bg-teal-600 hover:bg-teal-700 text-white py-2 px-4 rounded-lg font-medium transition-colors">
                    <i className="ri-phone-line mr-2"></i>
                    Appeler
                  </button>
                </div>

                {/* Détails de livraison */}
                <div className="bg-gray-50 rounded-lg p-4">
                  <h3 className="font-semibold text-gray-900 mb-3">Détails</h3>
                  <div className="space-y-2">
                    <div className="flex justify-between">
                      <span className="text-gray-600">Prix:</span>
                      <span className="font-medium">{deliveryData.price.toLocaleString()} FCFA</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Temps estimé:</span>
                      <span className="font-medium">{deliveryData.estimatedTime} min</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Type:</span>
                      <span className="font-medium">Express</span>
                    </div>
                  </div>
                </div>

                {/* Étapes de livraison */}
                <div className="bg-gray-50 rounded-lg p-4">
                  <h3 className="font-semibold text-gray-900 mb-3">Progression</h3>
                  <div className="space-y-3">
                    <div className="flex items-center space-x-3">
                      <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                      <div>
                        <p className="text-sm font-medium text-gray-900">Commande confirmée</p>
                        <p className="text-xs text-gray-500">14:30</p>
                      </div>
                    </div>
                    <div className="flex items-center space-x-3">
                      <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                      <div>
                        <p className="text-sm font-medium text-gray-900">Colis collecté</p>
                        <p className="text-xs text-gray-500">14:45</p>
                      </div>
                    </div>
                    <div className="flex items-center space-x-3">
                      <div className="w-3 h-3 bg-orange-500 rounded-full animate-pulse"></div>
                      <div>
                        <p className="text-sm font-medium text-gray-900">En cours de livraison</p>
                        <p className="text-xs text-gray-500">Maintenant</p>
                      </div>
                    </div>
                    <div className="flex items-center space-x-3">
                      <div className="w-3 h-3 bg-gray-300 rounded-full"></div>
                      <div>
                        <p className="text-sm text-gray-500">Livraison terminée</p>
                        <p className="text-xs text-gray-400">Bientôt</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Carte de suivi */}
            <DeliveryMap
              deliveryId={deliveryData.id}
              isDriver={false}
              pickupLocation={deliveryData.pickup}
              deliveryLocation={deliveryData.delivery}
              currentLocation={{ lat: 5.3482, lng: -3.9921 }}
            />
          </div>
        )}

        {/* Codes de suivi d'exemple */}
        {!deliveryData && (
          <div className="bg-white rounded-xl shadow-lg p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Codes de test disponibles</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
              {[
                { code: 'LIV-2024-001', type: 'Commerce', status: 'En livraison' },
                { code: 'CMD-2024-001567', type: 'Restaurant', status: 'En préparation' },
                { code: 'MISS-001', type: 'Livreur', status: 'Mission active' }
              ].map((item) => (
                <button
                  key={item.code}
                  onClick={() => setTrackingCode(item.code)}
                  className="p-4 border border-gray-200 rounded-lg hover:border-teal-500 hover:bg-teal-50 transition-colors text-left"
                >
                  <div className="font-medium text-gray-900">{item.code}</div>
                  <div className="text-sm text-gray-600">{item.type} • {item.status}</div>
                </button>
              ))}
            </div>
            
            <div className="bg-blue-50 rounded-lg p-4">
              <h4 className="font-semibold text-blue-900 mb-2">Comment obtenir votre code de suivi ?</h4>
              <div className="space-y-2 text-sm text-blue-800">
                <p>• <strong>Clients :</strong> Consultez votre <Link to="/client-dashboard" className="underline">tableau de bord</Link> ou vos SMS</p>
                <p>• <strong>Restaurants :</strong> Accédez à votre <Link to="/restaurant-dashboard" className="underline">espace restaurant</Link></p>
                <p>• <strong>Commerces :</strong> Retrouvez vos codes dans l'<Link to="/commercant-dashboard" className="underline">espace commerce</Link></p>
                <p>• <strong>Livreurs :</strong> Partagez vos missions depuis l'<Link to="/livreur-dashboard" className="underline">espace livreur</Link></p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
